export default __webpack_public_path__ + "media/images/front/about/point_2-da857517dfead5311bf7aaae21a53bfc.png";